"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import WaveDropMobileMenu from "./WaveDropMobileMenu";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
interface DropMobileMenuHandlerProps {
  readonly drop: ExtendedDrop;
  readonly children: React.ReactNode;
  readonly showReplyAndQuote: boolean;
  readonly onReply: () => void;
}
const LONG_PRESS_DURATION = 500; // milliseconds
const MOVE_THRESHOLD = 10; // pixels

export default function DropMobileMenuHandler(t0) {
  const $ = _c(25);
  const {
    drop,
    children,
    showReplyAndQuote,
    onReply
  } = t0;
  let t1;
  if ($[0] !== drop.id) {
    t1 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTemporaryDrop = t1;
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  const isMobile = useIsMobileDevice();
  const hasTouch = useIsTouchDevice() || isMobile;
  const longPressTimeout = useRef(null);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  let t2;
  if ($[2] !== hasTouch) {
    t2 = () => {
      if (!hasTouch) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[2] = hasTouch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLongPress = t2;
  let t3;
  if ($[4] !== handleLongPress || $[5] !== hasTouch || $[6] !== isTemporaryDrop) {
    t3 = e => {
      if (isTemporaryDrop) {
        return;
      }
      if (hasTouch) {
        e.preventDefault();
      }
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
      longPressTimeout.current = setTimeout(() => {
        setLongPressTriggered(true);
        handleLongPress();
      }, LONG_PRESS_DURATION);
    };
    $[4] = handleLongPress;
    $[5] = hasTouch;
    $[6] = isTemporaryDrop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleTouchStart = t3;
  let t4;
  if ($[8] !== hasTouch) {
    t4 = e_0 => {
      if (hasTouch && longPressTimeout.current) {
        e_0.preventDefault();
      }
      const touchX = e_0.touches[0]?.clientX;
      const touchY = e_0.touches[0]?.clientY;
      const deltaX = Math.abs(touchX - touchStartX.current);
      const deltaY = Math.abs(touchY - touchStartY.current);
      if ((deltaX > MOVE_THRESHOLD || deltaY > MOVE_THRESHOLD) && longPressTimeout.current) {
        clearTimeout(longPressTimeout.current);
        longPressTimeout.current = null;
      }
    };
    $[8] = hasTouch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleTouchMove = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (longPressTimeout.current) {
        clearTimeout(longPressTimeout.current);
        longPressTimeout.current = null;
      }
      setLongPressTriggered(false);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleTouchEnd = t5;
  let t6;
  if ($[11] !== onReply) {
    t6 = () => {
      setIsSlideUp(false);
      onReply();
    };
    $[11] = onReply;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleOnReply = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsSlideUp(false);
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleOnAddReaction = t7;
  let t8;
  if ($[14] !== drop || $[15] !== handleOnReply || $[16] !== isSlideUp || $[17] !== longPressTriggered || $[18] !== showReplyAndQuote) {
    t8 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onAddReaction={handleOnAddReaction} />;
    $[14] = drop;
    $[15] = handleOnReply;
    $[16] = isSlideUp;
    $[17] = longPressTriggered;
    $[18] = showReplyAndQuote;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== children || $[21] !== handleTouchMove || $[22] !== handleTouchStart || $[23] !== t8) {
    t9 = <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onTouchCancel={handleTouchEnd}>{children} {t8}</div>;
    $[20] = children;
    $[21] = handleTouchMove;
    $[22] = handleTouchStart;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}